import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextField, FormHelperText, FormGroup } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { commonStrings } from './StringBundle';

const useStyles = makeStyles(() => ({
  multiEmailList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '10px',
    '& div': {
      display: 'flex',
      alignItems: 'center',
      background: '#e1e1e1',
      padding: '5px 10px',
      borderRadius: '15px',
    },
    '& button': {
      marginLeft: '5px',
      cursor: 'pointer',
      border: 'unset',
      background: 'unset',
      fontWeight: 'bold',
    }
  },
  subText: {
    fontSize: '12px',
  }
}));

const validateEmail = (email) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

const MultiEmailInputField = ({
  name,
  control,
  label = 'Email',
  required = false,
  disabled = false,
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState('');
  const [showErrorMsg, setShowErrorMsg] = useState('');

 const labelWithAsterisk = required ? `${label} *` : label;

  const handleAddEmail = (value, onChange, emails) => {
    const email = value.trim();
    if (email && validateEmail(email) && !emails.includes(email)) {
      const newEmails = [...emails, email];
      onChange(newEmails);
      setInputValue("");
      setShowErrorMsg("");
    } else {
      setShowErrorMsg(commonStrings.emailinvalid);
    }    
  };

  const handleKeyDown = (e, onChange, emails) => {
    if (['Enter', ',', ' '].includes(e.key)) {
      e.preventDefault();
      handleAddEmail(inputValue, onChange, emails);
    }
  };

  const handleRemove = (index, onChange, emails) => {
    const newList = emails.filter((_, i) => i !== index);
    onChange(newList);
  };

  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <TextField
              fullWidth
              label={labelWithAsterisk}
              variant="outlined"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, onChange, value)}
              error={!!error}
              disabled={disabled}
            />
            <div className={classes.multiEmailList}>
              {value.map((email, index) => (
                <div key={index}>
                  {email}
                  <button type="button" onClick={() => handleRemove(index, onChange, value)}>x</button>
                </div>
              ))}
            </div>
            {!_.isEmpty(showErrorMsg) && <FormHelperText error>{showErrorMsg}</FormHelperText>}
            {<p className={classes.subText}>Enter email and press Enter, comma or space</p>}
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormGroup>
  );
};

export default MultiEmailInputField;